import { memo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@app/store";
import { t } from "@app/utils/translation";
import styles from "./Header.module.css";

export const Header = () => {
  const logoTypeUrl = useSelector((state: RootState) => state.setting.logoTypeUrl);
  const language = useSelector((state: RootState) => state.setting.language);

  return (
    <header className={styles.header}>
      <img className={styles.logo} src={logoTypeUrl} alt={t("CompanyLogo", language)} />
    </header>
  );
};

export const MemoHeader = memo(Header);
